import { useForm } from "@mantine/form";
import { useMutation } from "@tanstack/react-query";
import { login } from "../../../../api/agencyAdmin/auth";
import { useNavigate } from "react-router-dom";
import { getRoleAndToken, storeToken } from "../../../../utility/sessionStorage";
import { useEffect } from "react";

const useLogin = () => {
    const navigate = useNavigate()
    useEffect(() => {
        const { role, token } = getRoleAndToken()
        if (role === "agency" && token) {
            navigate("/agency/dashboard", {
                replace: true
            })
        }
        return () => {

        };
    }, []);
    const loginMutation = useMutation({
        mutationFn: login,
        onSuccess: async (response) => {
            try {
                storeToken(response?.data?.token, response?.data?.role)
                // Cookies.set('token', response?.data?.token, {
                //     // expires: 7,
                //     // path: '/',
                //     // sameSite: 'Lax'
                //     httpOnly: true,  // HTTP-only
                //     secure: process.env.NODE_ENV === 'production', // Secure in production
                //     sameSite: 'Lax', // SameSite attribute
                //     maxAge: 24 * 60 * 60 * 1000 // 1 day
                // });
                const event = new CustomEvent('update-token', { token: response?.data?.token });
                window.dispatchEvent(event);
                navigate("/agency/dashboard", {
                    replace: true
                })
            } catch (error) {
                console.error(error);
            }
        }
    })

    const form = useForm({
        initialValues: {
            email: '',
            password: '',
        },

        validate: {
            email: (value) => (/^\S+@\S+$/.test(value) ? null : 'Invalid email'),
        },

    });



    const handleLogin = form.onSubmit(async (values) => {
        loginMutation.mutate(values)
    })
    return { form, handleLogin, loginMutation }

}

export default useLogin
